import { ModalSpace, useLocalModal } from "src/components/views/mkt04/Modal/provider";
import ModalView from "src/components/views/mkt04/Modal/view";

export interface ModalProps {
  modalData: ModalSpace.ModalData;
  onCancelInternal: () => void;
  onSubmitInternal: () => void;
  placement?: "center" | "bottom";
  offset?: number;
}

const Modal = () => {
  const { isOpen, closeModal, modalData } = useLocalModal();
  const { actions, when } = modalData;

  if (!isOpen || !when) {
    return null;
  } else {
  }

  const onCancelInternal = () => {
    actions?.cancel?.func?.();
    closeModal();
  };

  const onSubmitInternal = () => {
    if (!!actions?.submit?.func) {
      actions?.submit?.func?.();
    } else {
      closeModal();
    }
  };
  const placement = (modalData as any)?.placement ?? "center";
  const offset = (modalData as any)?.offset ?? 0;
  const props: ModalProps = {
    modalData,
    onCancelInternal,
    onSubmitInternal,
    offset,
    placement,
  };

  return <ModalView {...props} />;
};

export default Modal;
